import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpService } from 'src/services/http.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { MatFormFieldControl } from '@angular/material/form-field';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-process-list-user',
  templateUrl: './process-list-user.component.html',
  styleUrls: ['./process-list-user.component.scss']
})
export class ProcessListUserComponent implements OnInit {

  form: FormGroup;
  users: any[] = [];
  assignedUsers: any[] = [];

  constructor(
    fb: FormBuilder,
    private http: HttpService,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ProcessListUserComponent>
  ) { 
    // console.log('DADOS PROCESS', data);
    this.form = fb.group({
      process_id: [data.processList.id, Validators.required],
      selectedUser: [ null, Validators.required ],
    })

  }

  ngOnInit(): void {
    this.getUsers();
    this.getAssignedUsers();
  }

  getUsers() {
    const user = JSON.parse(localStorage.getItem('token'));
    this.http.save('process_list:list_user', { company: user.company_id, id: this.data.processList.id })
      .subscribe(
        (result: any) => {
          this.users = result.data;
        },
        err => this.errorReport.showMessage(err)
    )
  }

  getAssignedUsers() {
    const user = JSON.parse(localStorage.getItem('token'));
    this.http.save('process_list:assign_user', { user_id: this.data.processList.created_by, process_id: this.data.processList.id })
      .subscribe(
        (result: any) => {
          this.assignedUsers = result.data;
        },
        err => this.errorReport.showMessage(err)
    )
  }

  removeUser(id) {
    this.http.delete('process_list:remove_user', { user_id: id, process_id: this.data.processList.id })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Usuário removido do Processo Seletivo!', 'OK', { duration: 3000 });
            this.dialogRef.close();
          } else {
            this.snackbar.open('Desculpe não foi possivel remover o usuário, tente novamente mais tarde!', 'OK', { duration: 3000 });
          }
        },
        err => this.errorReport.showMessage(err)
    )
  }

  submit() {
    const isValid = !this.form.invalid;
    const data = this.form.getRawValue();
    
    if (isValid) {
      this.http.save('process_list:user', data)
        .subscribe(
          (result: any) => {
            // console.log('resultado', result);
            if (result.type === 'OK') {
              this.snackbar.open('Usuário atribuido com sucesso!', 'OK', { duration: 3000 });
              this.dialogRef.close();
            } else {
              this.snackbar.open('Desculpe não foi possivel atribuir o usuário, tente novamente mais tarde!', 'OK', { duration: 3000 });
            }  
          },
          err => this.errorReport.showMessage(err)
        )

    }
  }

}
